import {
  GET_CHATS,
  GET_MESSAGES,
  ADD_MESSAGE,
  SET_CURRENT_CHAT,
  CHAT_ERROR,
  LOGOUT_CLIENT,
  TOGGLE_CHAT,
  MARK_CHAT_READ,
  DELETE_CHAT,
  UPDATE_ONLINE_USERS
} from '../actions/types';

const initialState = {
  chats: [],
  currentChat: null,
  messages: [],
  isOpen: false,
  loading: true,
  onlineUsers: [], // Lista de IDs de usuarios conectados
  error: {}
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  // Robustamente obtener el ID del chat como string
  const getSafeId = (val) => {
    if (!val) return null;
    if (typeof val === 'string') return val;
    if (typeof val === 'object' && val._id) return val._id.toString();
    return val.toString();
  };

  switch (type) {
    case UPDATE_ONLINE_USERS:
      return {
        ...state,
        onlineUsers: payload
      };
    case GET_CHATS:
      const currentChatID = getSafeId(state.currentChat);
      const updatedChatsList = payload.map(chat => {
        if (getSafeId(chat._id) === currentChatID) {
          const newUnread = { ...chat.unreadCount };
          Object.keys(newUnread).forEach(k => newUnread[k] = 0);
          return { ...chat, unreadCount: newUnread };
        }
        return chat;
      });
      return {
        ...state,
        chats: updatedChatsList,
        loading: false
      };
    case GET_MESSAGES:
      return {
        ...state,
        messages: payload,
        loading: false
      };
    case ADD_MESSAGE:
      const chatIDString = getSafeId(payload.chat) || getSafeId(payload.chatId);
      const messageIDString = getSafeId(payload._id);
      const currentChatIDString = getSafeId(state.currentChat);

      // 1. Evitar duplicados
      if (state.messages.some(m => getSafeId(m._id) === messageIDString)) {
        return state;
      }

      // 2. Actualizar la vista previa en la lista de chats (chats)
      const updatedChats = state.chats.map(chat => {
        if (getSafeId(chat._id) === chatIDString) {
          const senderIdStr = getSafeId(payload.sender);
          const isFromMe = senderIdStr === getSafeId(payload.userId);
          const isChatOpen = state.isOpen && state.currentChat && currentChatIDString === chatIDString;
          
          let newUnreadCount = { ...chat.unreadCount };
          const myIdStr = getSafeId(payload.userId);
          if (!isFromMe && !isChatOpen && myIdStr) {
            const currentCount = newUnreadCount[myIdStr] || 0;
            newUnreadCount[myIdStr] = currentCount + 1;
          }

          return { 
            ...chat, 
            lastMessage: payload, 
            updatedAt: payload.createdAt || Date.now(),
            unreadCount: newUnreadCount
          };
        }
        return chat;
      }).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

      const shouldAddMessage = state.currentChat && currentChatIDString === chatIDString;
      
      return {
        ...state,
        messages: shouldAddMessage ? [...state.messages, payload] : state.messages,
        chats: updatedChats,
        loading: false
      };
    case MARK_CHAT_READ:
      const readChatID = getSafeId(payload);
      return {
        ...state,
        chats: state.chats.map(chat => {
          if (getSafeId(chat._id) === readChatID) {
            const newUnreadCount = { ...chat.unreadCount };
            Object.keys(newUnreadCount).forEach(key => newUnreadCount[key] = 0);
            return { ...chat, unreadCount: newUnreadCount };
          }
          return chat;
        })
      };
    case DELETE_CHAT:
      return {
        ...state,
        chats: state.chats.filter(chat => chat._id !== payload),
        currentChat: state.currentChat?._id === payload ? null : state.currentChat,
        messages: state.currentChat?._id === payload ? [] : state.messages
      };
    case SET_CURRENT_CHAT:
      return {
        ...state,
        currentChat: payload,
        isOpen: true,
        loading: false
      };
    case TOGGLE_CHAT:
      return {
        ...state,
        isOpen: payload !== undefined ? payload : !state.isOpen
      };
    case CHAT_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      };
    case LOGOUT_CLIENT:
      return initialState;
    default:
      return state;
  }
}
